import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d1298042&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d1298042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1298042",
  null
  
)

export default component.exports